<template>
	<div class="income-table beautify-scroll">
		<a-table
			v-if="!hidden"
			:columns="columns"
			:data-source="tableDatas"
			:pagination="false"
			bordered
			:scroll="{ x: 800 }"
		>
        <template #bodyCell="{column, record}">
            <template v-if="column.key === 'incomeType'">
                <div>
                    <div>
                        {{ record.incomeType.split("-")[0] }}
                    </div>
                    <div style="color: rgba(0, 0, 0, 0.65)">
                        {{ record.incomeType.split("-")[1] }}
                    </div>
                </div>
            </template>
        </template>
    </a-table>
	</div>
</template>

<script setup>
	import { defineProps, ref, watch } from "vue";
	import { toFixed } from "@/plugins/index.js";

	const hidden = ref(true);
	// 表格
	const columns = ref([]);
	const tableDatas = ref([
		{
			type: "固定策略",
			incomeType: "日均收益-元/天"
		},
		{
			type: "固定策略",
			incomeType: "单位容量日均收益-元/(天*kWh)"
		},
		{
			type: "智能策略",
			incomeType: "日均收益-元/天"
		},
		{
			type: "智能策略",
			incomeType: "单位容量日均收益-元/(天*kWh)"
		}
	]);

	const props = defineProps({
		averageDatas: {
			type: Object,
			default: () => {
				return {};
			}
		}
	});

	// 处理表格数据
	const hanldeAverageData = () => {
		const { dayProfit, unitCapacityDayProfit } = props.averageDatas;

		// 生成列
		let newColumns = [
			{
				title: "",
				dataIndex: "type",
				key: "type",
				align: "center",
				width: "110px",

				// 合并垂直单元格
				customCell: (record, rowIndex, column) => {
					if (rowIndex % 2 === 0) {
						return {
							rowSpan: 2
						};
					}
					return {
						rowSpan: 0
					};
				}
			},
			{
				title: "",
				dataIndex: "incomeType",
				key: "incomeType",
				width: "160px",
			}
		];
		dayProfit.map(el => {
            let obj = {
                title: `${el.capacity}kWh`,
				dataIndex: `${el.capacity}`,
				key: `${el.capacity}`,
				align: "center",
            }
            if (dayProfit.length > 5) obj["width"] = 150;
            newColumns.push(obj);
		});

		if (dayProfit.length > 4) {
			newColumns[0].fixed = "left";
			newColumns[1].fixed = "left";
		}

		// 生成数据
		tableDatas.value.map((c, index) => {
			dayProfit.map(el => {
				if (index == 0) {
					c[el.capacity] = toFixed(el.prev, 2);
				}
				if (index == 2) {
					c[el.capacity] = toFixed(el.wise, 2);
				}
			});
			unitCapacityDayProfit.map(el => {
				if (index == 1) {
					c[el.capacity] = toFixed(el.prev, 4);
				}
				if (index == 3) {
					c[el.capacity] = toFixed(el.wise, 4);
				}
			});
		});
		columns.value = newColumns;

		hidden.value = false;
	};

	watch(
		() => props.averageDatas,
		(newVal, oldVal) => {
			console.log(newVal);
			hidden.value = true;
			console.log("@@@@@@@@@@@@@@@@@@@@");
			if (newVal && Object.keys(newVal).length > 0) {
				// 处理表格数据
				hanldeAverageData();
			}
		},
		{ immediate: true, deep: true }
	);
</script>

<style lang="less" scoped>
.income-table {
	margin-top: 16px;
}
::v-deep .ant-table-tbody {
	.ant-table-row {
		&:nth-child(2n) {
			.ant-table-cell {
				&:nth-child(-n + 2) {
					background-color: #fafafa !important;
				}
			}
		}
		&:nth-child(2n + 1) {
			.ant-table-cell {
				&:first-child {
					background-color: #fafafa !important;
				}
			}
		}
	}
}
</style>